import React, { createContext } from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import FlexContentHandler from 'components/shared/FlexContentHandler'

export const PostContext = createContext({
  title: '',
  image: null,
})

interface PageTemplateProps {
  data: {
    page: {
      path?: string
      title?: string
      seo: any
      flexContent: any
    }
  }
  location?: any
  prefix?: string
}

const PageTemplate: React.FC<PageTemplateProps> = ({
  data: {
    page: { title, recap, flexContent, seo },
  },
  location = {},
  prefix = 'post_Flexcontent',
}) => (
  <Layout>
    <SEO seo={seo} />
    <PostContext.Provider
      value={{
        title,
        image: recap.image,
      }}
    >
      <FlexContentHandler
        prefix={prefix}
        fields={flexContent}
        location={location}
      />
    </PostContext.Provider>
  </Layout>
)

export const pageQuery = graphql`
  query postById($pageId: String!) {
    page: wpPost(id: { eq: $pageId }) {
      ...generalPostFragment
    }
  }
`

export default PageTemplate
